<template>
    <div v-if="invoiceInfo.id" class="container">
        <div class="item-headder">
            <div> 
                <h2>{{invoiceInfo.note}}</h2>
                <p>
                    <span>#{{invoiceInfo.id}}</span>
                    <span class="pill green" v-if="invoiceInfo.payment_day">Paid</span>
                    <span class="pill red" v-else>Unpaid</span>
                </p>
            </div>
        </div>
        <div class="flex-side-by-side">
            <div>
                <h2>Customerinformation</h2>
                <div class="div-table row">
                    <div>
                        <p>ID</p>
                        <span>
                            {{invoiceInfo.customer_id}} 
                        </span>
                        <router-link tag="div" :to="'/customers/' + invoiceInfo.customer_id" class="btn sm">Show</router-link>
                    </div>
                    <div>
                        <p>Name</p>
                        <span>
                            {{invoiceInfo.customer_name}}
                        </span>
                    </div>
                    <div>
                        <p>Adress</p>
                        <span>
                            {{invoiceInfo.customer_address}}
                        </span>
                    </div>
                    <div>
                        <p>Postal-code</p>
                        <span>
                            {{invoiceInfo.customer_postal}}
                        </span>
                    </div>
                    <div v-if="invoiceInfo.customer_cvr != 0">
                        <p>CVR</p>
                        <span>
                            {{invoiceInfo.customer_cvr}}
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <h2>Invoiceinformation</h2>
                <div class="div-table row">
                    <div>
                        <p>ID</p>
                        <span>
                            #{{invoiceInfo.id}}
                        </span>
                    </div>
                    <div v-if="invoiceInfo.cart_id != 0">
                        <p>Cart ID</p>
                        <span>
                            #{{invoiceInfo.cart_id}}
                        </span>
                    </div>
                    <div>
                        <p>Note</p>
                        <span>
                            {{invoiceInfo.note}}
                        </span>
                    </div>
                    <div>
                        <p>Creation day</p>
                        <span>
                            {{dateTimeFormat(invoiceInfo.creation_day)}}
                        </span>
                    </div>
                    <div v-if="invoiceInfo.payment_day">
                        <p>Payment day</p>
                        <span>
                            {{dateTimeFormat(invoiceInfo.payment_day)}}
                        </span>
                    </div>
                    <div>
                        <p>Creator type</p>
                        <span class="capitalize">{{invoiceInfo.creator}}</span>
                    </div>
                </div>
            </div>
        </div>

        <h2>Products in invoice</h2>
        <table class="products-table">
            <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Product</th>
                <th>Status</th>
                <th></th>
                <th>Amount</th>
                <th>Unit Price</th>
                <th>Price</th>
            </tr>
            <tr v-for="row in invoiceInfo.data" :key="row.id">
                <td>#{{row.id}}</td>
                <td>{{row.action}}</td>
                <td v-if="row.product == 0"></td>
                <router-link v-else tag="td" class="clickable" :to="'/products/'+row.supportid">
                    {{row.supportid}}
                </router-link>
                <td>
                    <div v-if="row.status == 'waiting'" class="pill xl yellow">Waiting</div>
                    <div v-else-if="row.status == 'error'" class="pill xl red">Error</div>
                    <div v-else-if="row.status == 'succes'" class="pill xl green">Succes</div>
                </td>
                <td>
                    <div class="multiline">
                        <p>{{row.data_one}}</p>
                        <p>{{row.data_two}}</p>
                        <p>{{row.data_three}}</p>
                    </div>
                </td>
                <td>{{row.unit_amount}} {{row.unit_type}}</td>
                <td>{{row.unit_price}} DKK</td>
                <td>{{row.unit_price*row.unit_amount}} DKK</td>
            </tr>
            <tr>
                <td colspan="6"></td>
                <td>Total</td>
                <td>{{calculateInvoice}} DKK</td>
            </tr>
        </table>
    </div>
    <Loading v-else/>
</template>
<style scoped lang="scss">
.item-headder p{
    display: flex;
    align-items: center;
}
    .flex-side-by-side{
        display: flex;
        flex-wrap: wrap;
        margin: 0 -1rem;
        &>div{
            flex-grow: 2;
            margin: 1rem;
        }
    }
    .products-table{
        td .multiline{
            display: flex;
            flex-direction: column;
            p{
                margin: 0;
            }
        }
    }
</style>
<script>
import Loading from '@/components/parts/Loading.vue';

export default {
    name: 'Invoice',
    components: {Loading},
    data() {
        return {
            invoiceInfo: {},
        }
    },
    computed: {
        calculateInvoice(){
            var sum = 0;
            if(this.invoiceInfo.data.length>0){
                this.invoiceInfo.data.forEach(data => { sum += (data.unit_amount * data.unit_price)});
            }
            return sum;
        },
    },
    methods: {
        getInvoiceData(){
            var vue = this;
            this.$socket.client.emit('getInvoice',vue.$route.params.invoiceid, (error, response) => {
                if(error=='200'){
                    vue.invoiceInfo = response;
                }
            })
        },
        dateTimeFormat : function(input){
            var date = new Date(input);
            return date.getDate() + ". " + this.$store.state.monthsShort[date.getMonth()] + " " + date.getFullYear() + " - " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2);
        }
    },
    mounted() {
        this.getInvoiceData();
    },
    
}
</script>